import createAttachments from '../utils/createAttachments';
import getEventClientItemId from 'owa-calendar-compose-form-store/lib/utils/getEventClientItemId';
import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';
import { createAttachmentsFromFiles } from '../actions/createAttachmentsFromFiles';
import { orchestrator } from 'satcheljs';
import { setAttachmentFiles } from 'owa-calendar-compose-form-actions';
import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyInsertInlineImages } from 'owa-editor-inlineimage-plugin';

export default orchestrator(createAttachmentsFromFiles, async actionMessage => {
    // If the event has not been created, store the attachment files
    // details in the compose store. When the event has been created
    // the onDraftEventCreated action will result in the attachments
    // being created on the event
    const eventId = getEventClientItemId();
    const viewState = getFullComposeViewState();
    let { fileList, properties } = actionMessage;

    if (properties.isInline && isFeatureEnabled('cmp-inlineImageV2')) {
        const insertInlineImages = await lazyInsertInlineImages.import();
        fileList = await insertInlineImages(
            fileList,
            viewState.bodyViewState,
            viewState.inlineImageV2
        );
    }

    if (!eventId) {
        setAttachmentFiles(fileList, properties.shouldShare, properties.isInline);
        return;
    }

    // The event has already been created so can add the
    // attachments now.
    createAttachments(fileList, properties);
});

export { ClientItemId } from 'owa-client-ids';
export { AttachmentFileList } from 'owa-attachment-well-data';
